function createBloomreachResourceUrl(baseUrl, channel, resourceIds, locale) {
  if (!baseUrl || !channel) {
    throw new Error(
      `Failed to create Bloomreach CMS resource url. Need valid baseUrl and channel but got baseUrl: ${String(
        baseUrl
      )} and channel: ${channel} }`
    );
  }
  const localePath = locale ? `/${locale.replace("-", "_")}` : "";
  const queryParam = `?resourceBundleIds=${encodeURIComponent(resourceIds.join(","))}`;
  const url = baseUrl.includes(channel) ? baseUrl.replace(`/${channel}`, "") : baseUrl;
  return url + "/api/resources" + localePath + `/${channel}` + queryParam;
}
export {
  createBloomreachResourceUrl
};
//# sourceMappingURL=create-resource-url.js.map
